<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getTitleEmail }}</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="container section page-header section is-main-section">
      <b-tabs v-model="activeTab">
        <b-tab-item class="label" label="Filter">
          <form @submit.prevent="showListing">
            <card-component>
              <div class="columns row">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      Franchisee
                      <span class="requir">*</span>
                    </label>
                    <div class="control select is-fullwidth">
                      <select
                        required
                        v-model="email.franchiseeID"
                        :disabled="id"
                      >
                        <option value>---Select---</option>
                        <option
                          :value="franchisee.id"
                          v-for="franchisee in franchiseeArr"
                          :key="franchisee.id"
                        >
                          {{ franchisee.companyName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">
                      Email Template Type:
                      <span class="requir">*</span>
                    </label>
                    <div class="control select is-fullwidth">
                      <select
                        required
                        @change="changeTemplateType($event)"
                        v-model="email.emailTemplateType"
                      >
                        <option value="">---Select---</option>
                        <option
                          :value="type.id"
                          v-for="type in emailSendType"
                          :key="type.templateName"
                        >
                          {{ type.templateName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns row">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      To Mail:
                      <span class="requir">*</span>
                    </label>
                    <input
                      type="radio"
                      @change="checkToMail($event)"
                      style="margin-left: 20px"
                      id="Staff"
                      value="STAFF"
                      v-model="email.sendTo"
                    />
                    <label for="Staff" class="left-margin">Staff</label>
                    <input
                      type="radio"
                      @change="checkToMail($event)"
                      style="margin-left: 20px"
                      id="Parent"
                      value="PARENT"
                      v-model="email.sendTo"
                    />
                    <label for="Parent" class="left-margin">Parent</label>
                  </div>
                </div>

                <div class="column" v-show="ParentDiv">
                  <div class="field">
                    <label class="label">
                      Academic Year
                      <span class="requir">*</span>
                    </label>
                    <div class="control select is-fullwidth">
                      <select
                        :required="requiredP"
                        v-model="email.academicYearsValue"
                      >
                        <option value="">---Select---</option>
                        <option
                          :value="year.id"
                          v-for="year in academicYears"
                          :key="year.id"
                        >
                          {{ year.academicYear }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="column" v-show="StaffDiv">
                  <div class="field">
                    <label class="label">
                      Staff Department
                      <span class="requir">*</span>
                    </label>
                    <div class="control select is-fullwidth">
                      <select
                        v-model.trim="email.staffDepartmentType"
                        name="staffDepartmentType"
                        :disabled="id"
                      >
                        <option
                          :value="depts.name"
                          v-for="depts in deptsType"
                          :key="depts.name"
                        >
                          {{ depts.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns row" v-show="ParentDiv">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      Classes (Selected : {{ email.classes.length }})
                    </label>
                    <div class="control select is-fullwidth">
                      <multiselect
                        @select="Selected"
                        @remove="removeClass"
                        label="name"
                        track-by="name"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="classesArr"
                        v-model="email.classes"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.name }}
                          </span></template
                        >
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">
                      Class Sections (Selected : {{ email.section.length }})
                    </label>
                    <div class="control select is-fullwidth">
                      <multiselect
                        label="name"
                        track-by="name"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :auto-width="false"
                        :preserve-search="false"
                        :preselect-first="false"
                        :multiple="true"
                        :options="sectionArr"
                        v-model="email.section"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.name }}
                          </span></template
                        >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns row" v-show="ParentDiv">
                <div class="column is-9">
                  <div class="field">
                    <div class="control is-fullwidth">
                      <label class="label"><br /> </label>
                      <input
                        type="checkbox"
                        @change="checkBoxPoint($event)"
                        id="point_of_contact"
                        value="point_of_contact"
                        v-model="email.pointOfContact"
                      />
                      <label class="chk">Point Of Contact</label>
                      <input
                        type="checkbox"
                        @change="checkBoxPoint($event)"
                        id="Father"
                        value="Father"
                        :disabled="notPointChk"
                        v-model="email.pointOfContact"
                      />
                      <label class="chk">Parent</label>
                      <input
                        type="checkbox"
                        @change="checkBoxPoint($event)"
                        id="Mother"
                        value="Mother"
                        :disabled="notPointChk"
                        v-model="email.pointOfContact"
                      />
                      <label class="chk">Mother</label>
                      <input
                        type="checkbox"
                        @change="checkBoxPoint($event)"
                        id="Guardian"
                        value="Guardian"
                        :disabled="notPointChk"
                        v-model="email.pointOfContact"
                      />
                      <label class="chk">Guardian</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns row" v-show="ParentDiv">
                <div class="column">
                  <div class="field">
                    <label class="label">
                      Select Gender
                      <span class="requir">*</span>
                    </label>
                    <div class="control is-fullwidth">
                      <input
                        type="radio"
                        id="all"
                        value="all"
                        v-model="email.gender"
                      />
                      <label for="all" class="left-margin">All</label>
                      <input
                        type="radio"
                        style="margin-left: 20px"
                        id="girl"
                        value="FEMALE"
                        v-model="email.gender"
                      />
                      <label for="girl" class="left-margin">Girl</label>
                      <input
                        type="radio"
                        style="margin-left: 20px"
                        id="boy"
                        value="MALE"
                        v-model="email.gender"
                      />
                      <label for="boy" class="left-margin">Boy</label>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <label class="label"> Student Type </label>
                  <div class="field">
                    <div class="control is-fullwidth">
                      <input
                        type="radio"
                        id="all"
                        value="all"
                        v-model="email.studentType"
                      />
                      <label for="all" class="left-margin">All</label>
                      <input
                        type="radio"
                        style="margin-left: 20px"
                        id="isNewStudent"
                        value="isNewStudent"
                        v-model="email.studentType"
                      />
                      <label for="isNewStudent" class="left-margin"
                        >NewStudent</label
                      >
                      <input
                        type="radio"
                        style="margin-left: 20px"
                        id="isExistingStudent"
                        value="isExistingStudent"
                        v-model="email.studentType"
                      />
                      <label for="isExistingStudent" class="left-margin"
                        >ExistingStudent</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </card-component>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Continue</button>
            </footer>
          </form>
        </b-tab-item>
        <b-tab-item class="label" label="User Listing" :disabled="isListing">
          <form @submit.prevent="showMsgTab">
            <card-component>
              <div class="columns form-row">
                <div class="column is-12">
                  <div class="field">
                    <div class="label has-text-right right-align">
                      Total Count: <b> {{ total }}</b
                      ><br />
                      Selected Count: <b> {{ email.checkedRows.length }} </b>
                    </div>
                  </div>
                </div>
              </div>
              <section class="section is-main-section">
                <card-component class="has-table has-mobile-sort-spaced">
                  <b-input
                    placeholder="Search..."
                    type="search"
                    v-model="searchTerm"
                    @input="customSearch(searchTerm)"
                  ></b-input>
                  <b-table
                    checkable
                    :checked-rows.sync="email.checkedRows"
                    :paginated="paginated"
                    :per-page="10"
                    :columns="columns"
                    :striped="true"
                    :hoverable="true"
                    :data="searchFilterArray"
                    v-model="email.getAllData"
                  >
                    <section class="section" slot="empty">
                      <div class="content has-text-grey has-text-centered">
                        <template>
                          <p>
                            <b-icon icon="emoticon-sad" size="is-large" />
                          </p>
                          <p>Nothing's here&hellip;</p>
                        </template>
                      </div>
                    </section>
                  </b-table>
                </card-component>
              </section>
            </card-component>
            <footer class="column has-text-right">
              <button
                class="button is-success"
                type="submit"
                :disabled="isDisabled"
              >
                Next
              </button>
            </footer>
          </form>
        </b-tab-item>
        <b-tab-item class="label" label="Message Content" :disabled="isMessage">
          <form @submit.prevent="SendEmailToUser">
            <card-component>
              <div class="columns form-row">
                <div class="column is-10">
                  <div class="field">
                    <label class="label"> Subject: </label>
                    <div class="control form-row is-fullwidth">
                      <input
                        type="text"
                        v-model.trim="email.emailSubject"
                        :disabled="emailSubTxtBox"
                        @keypress="onKeyPressTxtEmailSub($event)"
                        @keydown="onKeyPressTxtEmailSub($event)"
                        @keyup="onKeyPressTxtEmailSub($event)"
                        class="input"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns form-row" v-show="SendEmailSubTextDiv">
                <div class="column is-10">
                  <div class="field">
                    <div class="control">
                      <label class="label"> Subject Will be : </label>
                      {{ SendEmailSubText }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns form-row">
                <div class="column is-10">
                  <div class="field">
                    <label class="label"> Email Content </label>
                    <ckeditor
                      v-model="email.emailEditorData"
                      :read-only="emailContentTxtBox"
                      ref="ckeditorRef"
                    >
                    </ckeditor>
                  </div>
                </div>
              </div>
              <div class="columns form-row" v-show="SendEmailTextDiv">
                <div class="column is-10">
                  <div class="field">
                    <label class="label">
                      Note : Content replace with {EMAIL_CONTENT}
                    </label>
                  </div>
                  <div
                    class="control"
                    style="font-weight: normal"
                    v-html="SendEmailText"
                  ></div>
                </div>
              </div>
              <div class="column form-row" v-show="uploadDiv">
                <label class="body-2 font-weight-medium"> Select file </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onFilechange(this)"
                    v-model="dropFile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .xls , .xlsx, .doc, pdf, .docx, .pptx, .ppt ,
                  .jpg , .jpeg gif , .png , .svg , .webp , .apng , .avif ]
                </div>
                <div v-if="dropFile.length > 0">
                  <v-chip
                    v-for="(file, i) in dropFile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deleteDropFile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </div>
              </div>
            </card-component>
            <footer class="column has-text-right">
              <button
                class="button is-success"
                type="submit"
                :disabled="isDisabled"
              >
                Send Email
              </button>
            </footer>
          </form>
        </b-tab-item>
      </b-tabs>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import Multiselect from 'vue-multiselect'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
import _ from 'lodash'
// Vue.use(CKEditor)

export default {
  name: 'sendEmail',
  components: {
    CardComponent,
    Multiselect
  },
  props: ['id'],
  data () {
    return {
      isListing: true,
      isMessage: true,
      uploadDiv: false,
      activeTab: 0,
      getTitleEmail: 'Send Email',
      franchiseeArr: [],
      classesArr: [],
      sectionArr: [],
      academicYears: [],
      data: [],
      searchFilterArray: [],
      total: 0,
      paginated: false,
      perPage: 10,
      selectTextChk: 'For Selected Staff Only',
      MsgText: 'Message:(Should starts with Dear Sir/Madam)',
      emailSendType: [],
      deptsType: [
        { name: 'All' },
        { name: 'Teaching' },
        { name: 'Non Teaching' }
      ],
      loadingComponent: null,
      ParentDiv: false,
      StaffDiv: true,
      emailDiv: true,
      SendEmailTextDiv: false,
      SendEmailText: '',
      SendEmailSubText: '',
      SendEmailSubTextDiv: false,
      emailSendDiv: false,
      notPointChk: true,
      pointChk: false,
      back: false,
      emailSubTxtBox: false,
      emailContentTxtBox: false,
      searchTerm: '',
      isDisabled: false,
      columns: [],
      TableData: [],
      templateDeatils: [],
      requiredP: false,
      requiredS: false,
      staffArr: ['ALL', 'STAFF'],
      parentArr: ['ALL', 'PARENT'],
      allowedFiles: [
        'xls',
        'xlsx',
        'doc',
        'pdf',
        'docx',
        'pptx',
        'ppt',
        'jpg',
        'jpeg',
        'gif',
        'png',
        'svg',
        'webp',
        'apng',
        'avif'
      ],
      dropFile: [],
      email: {
        franchiseeID: '',
        emailTemplateType: '',
        sendTo: 'STAFF',
        addCC: '',
        staffDepartmentType: 'All',
        templateTypeValue: '',
        academicYearsValue: '',
        pointOfContact: ['point_of_contact'],
        classes: '',
        staffDept: '',
        section: '',
        gender: 'all',
        studentType: 'all',
        selectedStudent: '',
        messageText: '',
        emailEditorData: '',
        emailSubject: '',
        getAllData: '',
        checkedRows: []
      }
    }
  },
  async created () {
    try {
      this.getTitleEmail = 'Send Email'
      this.getDetails()
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage =
        (e && e.response && e.response.data.message) || e.message
      this.errMsg(errorMessage)
    }
  },
  watch: {
    activeTab (tabNo) {
      if (tabNo === 1) {
        this.isMessage = true
      } else if (tabNo === 0) {
        this.isMessage = true
        this.isListing = true
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    const that = this.$refs.ckeditorRef
    const maximizedState = that.instance.getCommand('maximize').state
    if (maximizedState === 1) {
      that.instance.execCommand('maximize')
    }
    if (this.hasDataChanged()) {
      return this.$buefy.dialog.confirm({
        title: 'Leave Page',
        message: 'Do you really want to leave? you have unsaved changes!',
        type: 'is-danger',
        cancelText: 'No',
        confirmText: 'Yes',
        onConfirm: () => {
          next()
        },
        onCancel: () => {
          next(false)
        }
      })
    } else next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
        (this.email.emailSubject && !this.emailSubTxtBox) ||
        (this.email.emailEditorData && !this.emailContentTxtBox)
      return boolAlert
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.TableData
      } else {
        if (this.email.sendTo.toString() === 'PARENT') {
          this.searchFilterArray = _.filter(
            this.TableData,
            (item) =>
              (this.email.pointOfContact.includes('point_of_contact') &&
                item &&
                item.StudentName.toLowerCase().search(value.toLowerCase()) >=
                  0) ||
              (item &&
                item.Class.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (item &&
                item.Section.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.email.pointOfContact.includes('point_of_contact') &&
                item &&
                item.pointOfContact.toLowerCase().search(value.toLowerCase()) >=
                  0) ||
              (this.email.pointOfContact.includes('Father') &&
                item &&
                item.Father.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.email.pointOfContact.includes('Mother') &&
                item &&
                item.Mother.toLowerCase().search(value.toLowerCase()) >= 0) ||
              (this.email.pointOfContact.includes('Guardian') &&
                item &&
                item.Guardian.toLowerCase().search(value.toLowerCase()) >= 0)
          )
        } else if (this.email.sendTo.toString() === 'STAFF') {
          this.searchFilterArray = _.filter(
            this.TableData,
            (item) =>
              (item &&
                item.StaffName.toLowerCase().search(value.toLowerCase()) >=
                  0) ||
              (item &&
                item.StaffEmailId.toLowerCase().search(value.toLowerCase()) >=
                  0)
          )
        }
      }
      this.total = this.searchFilterArray.length
    },
    GetUserListing: function () {
      this.TableData = []
      if (this.email.sendTo.toString() === 'PARENT') {
        this.TableData = []
        this.data.forEach((Obj) => {
          let dataObj = {}
          dataObj['StudentName'] = Obj.studentEnrollment.studentName
          dataObj['userId'] = Obj.id
          dataObj['FatherName'] = Obj.studentEnrollment.fatherName
          if (this.email.pointOfContact.includes('point_of_contact')) {
            dataObj['pointOfContact'] = Obj.studentEnrollment.fatherEmailID
          }
          if (this.email.pointOfContact.includes('Father')) {
            dataObj['Father'] = Obj.studentEnrollment.fatherEmailID
          }
          if (this.email.pointOfContact.includes('Mother')) {
            dataObj['Mother'] = Obj.studentEnrollment.motherEmailID
          }
          if (this.email.pointOfContact.includes('Guardian')) {
            dataObj['Guardian'] = Obj.studentEnrollment.guardianEmailID
          }
          dataObj['Class'] = Obj.studentClass.name
          dataObj['Section'] = Obj.studentSection.name
          this.TableData.push(dataObj)
        })
        this.columns = [
          { field: 'userId', label: 'Student Id', visible: false }
        ]
        this.columns = [
          { field: 'FatherName', label: 'Parent Name', visible: false }
        ]

        this.columns = [{ field: 'StudentName', label: 'Student Name' }]
        if (this.email.pointOfContact.includes('point_of_contact')) {
          this.columns.push({
            field: 'pointOfContact',
            label: 'Point Of Contact'
          })
        }
        if (this.email.pointOfContact.includes('Father')) {
          this.columns.push({ field: 'Father', label: 'Parent' })
        }
        if (this.email.pointOfContact.includes('Mother')) {
          this.columns.push({ field: 'Mother', label: 'Mother' })
        }
        if (this.email.pointOfContact.includes('Guardian')) {
          this.columns.push({ field: 'Guardian', label: 'Guardian' })
        }
        this.columns.push(
          { field: 'Section', label: 'Section' },
          { field: 'Class', label: 'Class' }
        )
        this.searchFilterArray = this.TableData
      } else if (this.email.sendTo.toString() === 'STAFF') {
        this.TableData = []
        this.columns = [
          { field: 'StaffName', label: 'Staff Name' },
          { field: 'userId', label: 'Staff ID', visible: false },
          { field: 'StaffEmailId', label: 'Email ID' },
          { field: 'StaffType', label: 'Staff Type' }
        ]
        this.data.forEach((Obj) => {
          let dataObj = {}
          dataObj['StaffName'] = Obj.user.firstName + ' ' + Obj.user.lastName
          dataObj['userId'] = Obj.user.userStaff.userID
          dataObj['StaffEmailId'] = Obj.user.email
          dataObj['StaffType'] = Obj.user.userStaff.isTeachingStaff
            ? 'Teaching'
            : 'Non Teaching'
          this.TableData.push(dataObj)
        })
        this.searchFilterArray = this.TableData
      }
    },
    getEmailTemplate: async function (templateUserTypeArr) {
      try {
        let filterTemplateData = {
          templateType: 'EMAIL',
          templatePageType: 'SEND_EMAIL',
          templateUserType: templateUserTypeArr
        }
        const dataTemplate = await http.post(
          `${constants.API_URL}/api/communication/template/details`,
          filterTemplateData
        )
        if (dataTemplate.data.count > 0) {
          this.required = true
          this.emailSendType = dataTemplate.data.rows
        } else {
          this.emailSendType = []
          this.required = false
        }
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    getEmailTemplateContent: async function (templateId) {
      try {
        const dataTemplate = await http.get(
          `${constants.API_URL}/api/communication/template/${templateId}`
        )
        this.templateDeatils = dataTemplate.data
        if (
          this.templateDeatils.templateSenderKey === '201649' ||
          this.templateDeatilstemplateSenderKey === '201650'
        ) {
          this.email.emailEditorData = window.atob(
            this.templateDeatils.templateContent
          )
          this.email.emailSubject = this.templateDeatils.templateEmailSubject
          this.emailSubTxtBox = true
          this.emailContentTxtBox = true
          this.uploadDiv = true
        } else if (
          this.templateDeatils.templateSenderKey === '201651' ||
          this.templateDeatilstemplateSenderKey === '201652'
        ) {
          this.emailSubTxtBox = false
          this.emailContentTxtBox = false
          this.email.emailEditorData = ''
          this.email.emailSubject = ''
          this.uploadDiv = false
        } else {
          this.emailSubTxtBox = false
          this.emailContentTxtBox = false
          this.email.emailEditorData = ''
          this.email.emailSubject = ''
          this.uploadDiv = false
        }
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    getDetails: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        this.franchiseeArr = data.rows
        const classesData = await http.get(
          `${constants.API_URL}/api/students/class`
        )
        this.classesArr = classesData.data.rows
        const dataAcademicYears = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = dataAcademicYears.data.rows
        this.getEmailTemplate(this.staffArr)
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    checkToMail: function (event) {
      if (event.target.value === 'PARENT') {
        this.ParentDiv = true
        this.StaffDiv = false
        this.requiredP = true
        this.requiredS = true
        this.MsgText = 'Message:(Should starts with Dear Sir/Madam/Student)'
        this.selectTextChk = 'For Selected Student Only'
        this.getEmailTemplate(this.parentArr)
      } else if (event.target.value === 'STAFF') {
        this.requiredP = false
        this.requiredS = true
        this.ParentDiv = false
        this.StaffDiv = true
        this.selectTextChk = 'For Selected Staff Only'
        this.MsgText = 'Message:(Should starts with Dear Sir/Madam)'
        this.getEmailTemplate(this.staffArr)
      }
    },
    checkBoxPoint: function (event) {
      if (
        event.target.checked === true &&
        event.target.value === 'point_of_contact'
      ) {
        this.notPointChk = true
        this.pointChk = false
        this.email.pointOfContact = ['point_of_contact']
      } else if (
        event.target.checked === false &&
        event.target.value === 'point_of_contact'
      ) {
        this.pointChk = true
        this.notPointChk = false
        this.email.pointOfContact = ['Father']
      } else if (
        !this.email.pointOfContact.includes('Guardian') &&
        !this.email.pointOfContact.includes('Father') &&
        !this.email.pointOfContact.includes('Mother')
      ) {
        this.notPointChk = true
        this.pointChk = false
        this.email.pointOfContact = ['point_of_contact']
      }
    },
    changeTemplateType: function (event) {
      let templateId = event.target.value
      this.getEmailTemplateContent(templateId)
    },
    Selected: function (value, id) {
      let classname = value.name
      let updatearr = {}
      value.studentSections.forEach((Obj) => {
        updatearr = {
          id: Obj.id,
          name: classname + '-' + Obj.name
        }
        this.sectionArr.push(updatearr)
      })
    },
    removeClass: function (value, id) {
      let idArr = []
      value.studentSections.forEach((Obj) => {
        idArr.push(Obj.id)
      })
      this.sectionArr = this.sectionArr.filter(
        (item) => !idArr.includes(item.id)
      )
      this.email.section = ''
    },
    showListing: async function () {
      this.email.checkedRows.length = 0
      this.email.checkedRows = []
      this.isMessage = true
      this.loadingComponent = this.$buefy.loading.open()
      if (this.emailSendType.length === 0) {
        this.errMsg(`Please Add Email Template for Send_Email Page`)
      } else {
        if (this.email.sendTo.toString() === 'PARENT') {
          if (this.email.classes.length === 0) {
            this.errMsg('Please Select Atleast One Class')
          } else if (this.email.section.length === 0) {
            this.errMsg('Please Select Atleast One Section of Class')
          } else if (
            this.email.classes.length > 0 &&
            this.email.section.length > 0
          ) {
            this.activeTab = 1
            this.isListing = false
            let classesIds = []
            if (this.email.classes) {
              this.email.classes.forEach((Obj) => {
                classesIds.push(Obj.id)
              })
            }
            let sectionIds = []
            if (this.email.section) {
              this.email.section.forEach((Obj) => {
                sectionIds.push(Obj.id)
              })
            }
            let filterData = {}
            filterData.franchiseeID = this.email.franchiseeID
            if (classesIds) {
              filterData.classID = classesIds
            }
            if (sectionIds) {
              filterData.sectionID = sectionIds
            }
            filterData.academicYearID = this.email.academicYearsValue
            filterData.isActive = true
            if (this.email.studentType === 'isExistingStudent') {
              filterData.isNewStudent = false
              filterData.isExistingStudent = true
            } else if (this.email.studentType === 'isNewStudent') {
              filterData.isNewStudent = true
              filterData.isExistingStudent = false
            } else {
              filterData.isNewStudent = false
              filterData.isExistingStudent = false
            }
            if (this.email.gender !== 'all') {
              filterData.gender = this.email.gender
            }
            try {
              const response = await http.post(
                `${constants.API_URL}/api/student/`,
                filterData
              )
              this.data = response.data
              this.total = this.data.length
              this.paginated = !!this.total
            } catch (e) {
              const errorMessage =
                (e && e.response && e.response.data.message) || e.message
              this.errMsg(
                `Error While Listing of Student Data: ${errorMessage}`
              )
            } finally {
              this.loadingComponent.close()
            }
          }
        } else if (this.email.sendTo.toString() === 'STAFF') {
          this.activeTab = 1
          this.isListing = false
          let appendUrl = ''
          if (this.email.staffDepartmentType === 'Teaching') {
            appendUrl = '&isTeachingStaff=1'
          } else if (this.email.staffDepartmentType === 'Non Teaching') {
            appendUrl = '&isTeachingStaff=0'
          }
          try {
            const response = await http.get(
              `${constants.API_URL}/api/staff/approved?franchiseeID=${this.email.franchiseeID}${appendUrl}`
            )
            this.data = response.data
            this.total = this.data.length
            this.paginated = !!this.total
          } catch (e) {
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.errMsg(`Error While Listing of Student Data: ${errorMessage}`)
          } finally {
            this.loadingComponent.close()
          }
        }
        if (this.total === 0) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      }
      this.loadingComponent.close()
      this.GetUserListing()
    },

    onKeyPressTxtEmailSub: function (event) {
      this.SendEmailSubText = this.templateDeatils.templateEmailSubject
      this.SendEmailSubTextDiv = true
      if (this.templateDeatils.templateSenderKey === '201651') {
        this.SendEmailSubText = this.SendEmailSubText.replace(
          '{ANNOUNCEMENT_NAME}',
          event.target.value
        )
      } else if (this.templateDeatils.templateSenderKey === '201652') {
        this.SendEmailSubText = this.SendEmailSubText.replace(
          '{GREETING_NAME}',
          event.target.value
        )
      }
    },
    showMsgTab: function () {
      if (this.email.checkedRows.length === 0) {
        this.errMsg('Please Select Atleast One User')
      } else {
        this.activeTab = 2
        this.isMessage = false
        this.SendEmailTextDiv = false
        this.uploadDiv = false
        this.SendEmailSubTextDiv = false
        if (
          this.templateDeatils.templateSenderKey === '201651' ||
          this.templateDeatils.templateSenderKey === '201652'
        ) {
          this.SendEmailTextDiv = true
          this.uploadDiv = true
          this.SendEmailText = window.atob(this.templateDeatils.templateContent)
          this.SendEmailText = this.SendEmailText.replaceAll('<p>', ' ')
          this.SendEmailText = this.SendEmailText.replaceAll('</p>', ' ')
        }
      }
    },
    SendEmailToUser: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.isDisabled = true
        let filterData = {}
        let formData = new FormData()
        this.userIDs = []
        if (this.email.checkedRows.length > 0) {
          this.email.checkedRows.forEach((Obj) => {
            if (Obj.userId && !this.userIDs.includes(Obj.userId)) {
              this.userIDs.push(Obj.userId)
            }
          })
        }
        if (this.userIDs.length !== 0) {
          formData.append('userIDs', JSON.stringify(this.userIDs))
        }
        // filterData.userIDs = this.userIDs
        formData.append('franchiseeID', this.email.franchiseeID)
        // filterData.franchiseeID = this.email.franchiseeID
        if (this.email.sendTo.toString() === 'PARENT') {
          let pointOfContact = this.email.pointOfContact
          pointOfContact = pointOfContact.map(function (x) {
            return x.toUpperCase()
          })
          formData.append('pointOfContact', JSON.stringify(pointOfContact))
          formData.append('userType', 'ENROLL')
          // filterData.pointOfContact = this.email.pointOfContact
          // filterData.userType = 'ENROLL'
        } else {
          let pointOfContact = ['point_of_contact']
          pointOfContact = pointOfContact.map(function (x) {
            return x.toUpperCase()
          })
          formData.append('pointOfContact', JSON.stringify(pointOfContact))
          formData.append('userType', this.email.sendTo)
          // filterData.userType = this.email.sendTo
          // filterData.pointOfContact = ['point_of_contact']
        }
        filterData.templateID = this.email.emailTemplateType
        formData.append('templateID', this.email.emailTemplateType)
        if (
          this.templateDeatils.templateSenderKey === '201651' ||
          this.templateDeatils.templateSenderKey === '201652'
        ) {
          if (this.email.emailSubject === '' && !this.email.emailSubject) {
            this.loadingComponent.close()
            this.isDisabled = false
            return this.errMsg(`Please Add Email Subject`)
          }
          if (
            this.email.emailEditorData === '' &&
            !this.email.emailEditorData
          ) {
            this.loadingComponent.close()
            this.isDisabled = false
            return this.errMsg(`Please Add Email Template Content`)
          }
          formData.append(
            'emailContent',
            window.btoa(this.email.emailEditorData)
          )
          formData.append('emailSub', window.btoa(this.email.emailSubject))
          // filterData.emailContent = window.btoa(this.email.emailEditorData)
          // filterData.emailSub = window.btoa(this.email.emailSubject)
        }
        filterData.pageName = 'SEND_EMAIL'
        if (this.dropFile.length > 0) {
          for (let i = 0; i < this.dropFile.length; i++) {
            formData.append('file', this.dropFile[i])
          }
        }
        formData.append('pageName', 'SEND_EMAIL')
        if (
          this.templateDeatils.templateSenderKey.trim() === '201649' ||
          this.templateDeatils.templateSenderKey.trim() === '201651' ||
          this.templateDeatils.templateSenderKey.trim() === '201652'
        ) {
          const sendSMSCount = await http.post(
            `${constants.API_URL}/api/communication/notifications/email`,
            formData
          )
          this.sectionArr = []
          this.clearData()
          this.activeTab = 0
          if (sendSMSCount.data.SendCount > 0) {
            return this.okMsg(
              `${sendSMSCount.data.SendCount} Email Send Successfully`
            )
          } else {
            return this.okMsg(`Email Not Sent,Please try Again`)
          }
        }
      } catch (e) {
        this.errMsg(e.message)
      } finally {
        this.loadingComponent.close()
      }
    },
    clearData: function () {
      this.email.franchiseeID = ''
      this.email.emailTemplateType = ''
      this.email.addCC = ''
      this.email.staffDepartmentType = 'All'
      this.email.templateTypeValue = ''
      this.email.academicYearsValue = ''
      this.email.pointOfContact = ['point_of_contact']
      this.email.classes = ''
      this.email.staffDept = ''
      this.email.section = ''
      this.email.gender = 'all'
      this.email.studentType = 'all'
      this.email.selectedStudent = ''
      this.email.messageText = ''
      this.email.emailEditorData = ''
      this.email.emailSubject = ''
      this.email.getAllData = ''
      this.email.checkedRows = []
      this.sectionArr = []
      this.dropFile = []
    },
    onFilechange (e) {
      let files = this.dropFile
      let fileNamearr = []
      this.dropFile = files.filter((item, index, array) => {
        if (!fileNamearr.includes(item.name)) {
          fileNamearr.push(item.name)
          return item
        }
      })
      let sizeFile = 0
      let output = files.reduce((acc, curr) => {
        sizeFile = sizeFile + parseInt(curr.size)
        return sizeFile
      }, {})
      let size = output > 1500000
      if (size) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: `file size is too big`,
          title: 'File Upload Error'
        })
      }
      let r1 = this.dropFile.some((a) => {
        return this.dropFile.includes(a.name)
      })
      if (r1 === true) {
        this.dropFile.pop()
        return this.$dialog.warning({
          text: 'Kindly Not allow same file name!',
          title: 'Error'
        })
      }
      let r = this.dropFile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.dropFile.some((a, index) => {
          if (!this.allowedFiles.includes(a.name.split('.').pop())) {
            this.dropFile.splice(index, 1)
          }
        })
        return this.$dialog.warning({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
      if (this.dropFile.length > 5) {
        this.dropFile.pop()
        return this.$buefy.toast.open({
          message: 'You are only allowed to upload a maximum of 5 files',
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style>
.left-margin {
  margin-left: 5px;
}
.chk {
  margin-left: 10px;
  margin-right: 10px;
}
.hidecolumn {
  display: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
